import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import TrustSection from "./components/TrustSection";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import MethodologySection from "./components/MethodologySection";
import ResultsSection from "./components/ResultsSection";
import InsightsSection from "./components/InsightsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import HomeV2 from "./components/v2/HomeV2";

// Version 1 - Original (Beige theme with rectangular elements)
const HomeV1 = () => {
  return (
    <div className="App" data-testid="app-container">
      <Header />
      <main>
        <HeroSection />
        <TrustSection />
        <AboutSection />
        <ServicesSection />
        <MethodologySection />
        <ResultsSection />
        <InsightsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeV1 />} />
        <Route path="/v2" element={<HomeV2 />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
